import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// English only: there are no other locale resources, so the language is fixed and never
// detected from the browser (an indexed URL must always render the same language).
i18n
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
